import React from "react"

import { RouteObject } from "react-router-dom"

import {
  DashboardStoreInventoryShow,
  DashboardStoreInventoryShowProps,
} from "~/src/components/DashboardStores/InventoryShow"
import { ErrorPage } from "~/src/components/ErrorPage"
import { appClient } from "~/src/lib/appClients"

export const basename = "/dashboard/stores"

const createRoutes = (): RouteObject[] => [
  {
    path: `${basename}/:id/inventory`,
    element: <DashboardStoreInventoryShow />,
    hydrateFallbackElement: <></>,
    errorElement: <ErrorPage />,
    async loader({ request, params }): Promise<DashboardStoreInventoryShowProps> {
      const { id } = params
      const url = new URL(request.url)
      const response = await appClient.get(`${basename}/${id}/inventory`, {
        headers: { Accept: "application/json" },
        params: url.searchParams,
      })

      return response.data
    },
    children: [],
  },
]

export default createRoutes
